import React, { useState } from "react";

import ApproverAllPage from "./ApproverAll";
import ApproverSubmittedPage from "./ApproverSubmitted";
import ApproverAcceptedPage from "./ApproverAccepted";
import ApproverRejectedPage from "./ApproverRejected";
import ApproverTrackPage from "./ApproverTrack";

function Approve({userDetails, setParentLoading, activeApproverTab}){
return (
        <div >
             
                {/* CONTENTS */}

                <div
                    style={{
                    width: "100%",
                    minHeight: "100vh",
                    overflowY: "auto",
                    padding: "10px",
                    boxSizing: "border-box"
                }}
                >

                    {/* ALL */}

                    {activeApproverTab === "approverall" &&
                        <div className="fade-container">
                          <ApproverAllPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    {/* SUBMITTED */}

                    {activeApproverTab === "approversubmitted" &&
                        <div className="fade-container">
                          <ApproverSubmittedPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    {/* ACCEPTED */}

                    {activeApproverTab === "approveraccepted" &&
                        <div className="fade-container">
                          <ApproverAcceptedPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    {/* REJECTED */}

                    {activeApproverTab === "approverrejected" &&
                        <div className="fade-container">
                          <ApproverRejectedPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    {/* TRACK */}

                    {activeApproverTab === "approvertrack" &&
                        <div className="fade-container">
                          <ApproverTrackPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }
                   

                </div>

        </div>
    )
}

export default Approve;